// TODO IMPLEMENT - THIS IS JUST A STUB
import { action, observable } from "mobx"
import store                  from "store"
import config                 from "config";
// import _ from "lodash"
const STORE_KEY = "bshop::orderlists"
import shop                   from "shop/shop"
import _                      from "lodash"

//im element (json objekt) gibt es immer ein attribute "etag".
//
// element initial anlegen:
// fetch('https://orthotest.trend-soft.de/shop/rest/data/v1/customer/jsonstore/mytest?utag=',{method:'POST',body: JSON.stringify({"test":123}) })
//
// aktuelles element lesen aus dem store:
// fetch('https://orthotest.trend-soft.de/shop/rest/data/v1/customer/jsonstore/mytest?etag=')
//
// element aktualisieren (utag = etag von dem element):
// fetch('https://orthotest.trend-soft.de/shop/rest/data/v1/customer/jsonstore/mytest?utag=${element.etag}',{method:'POST',body: JSON.stringify({"test":123}) })

export default class ServerStore {
  
  @observable etagByName = {}
  @observable serverObjectCache = {}
  @observable lists = {}
  
  constructor( shop ) {
    this.shop = shop
    shop.events.authentified.add( this.onLogin )
  }
  
  onLogin = () => {
    this.hydrate()
  }
  
  async hydrate() {
    const data = await this.get()
    try {
      Object.keys( data ).forEach( k => {
        let key = decodeURIComponent( k )
        const obj = data[ k ]
        if ( obj && key.startsWith( "list-" ) ) {
          obj.title && shop.orderlist.createList( obj )
        }
        if ( obj ) {
          const etag = obj.etag
          this.etagByName[ key ] = etag
          this.serverObjectCache[ key ] = obj
        }
        return obj
      } )
    }
    catch (err) {
      console.error( "ERROR PARSING SERVERSTORE", err )
    }
    
    // IMPORT LOCAL LIST TO CLOUD
    // const uploadableLists = _.filter(shop.orderlist.lists, (e => !e.etag))
    // uploadableLists.forEach( list => {
    //   let etag = list.save()
    //   list.etag = etag
    // })
  }
  
  updateByName = {}
  
  post( name, value ) {
    const etag = this.etagByName[ name ]
    
    if ( etag ) {
      return this.put( name, value, etag )
    }
    return shop.fetchText( `/shop/rest/data/v1/customer/jsonstore/${(name)}?utag=`, { method: 'POST', body: JSON.stringify( value ) } )
               .then( etagNew => {
                 this.etagByName[ name ] = etagNew
               } )
               .catch( err => {
                 console.error( "ERROR ON SERVERSTORE", err )
                 shop.toast( translate( "Fehler bei der Abfrage ihrer Merkliste" ), "error" )
                 return false
               } )
    
  }
  
  get( name = "" ) {
    return this.shop.fetch( `/shop/rest/data/v1/customer/jsonstore/${name}?utag=` )
               .catch( err => {
                 return {}
               } )
  }
  
  put( name, value, etag ) {
    const requestQueue = this.updateByName[ name ]
    if ( requestQueue ) {
      let update = Object.assign( requestQueue || {}, value )
      update.isDirty = true
      this.updateByName[ name ] = update
      return false
    } else {
      this.updateByName[ name ] = value
    }
    etag = etag || this.etagByName[ name ]
    if ( !etag ) {
      console.error( "CAN'T Update without ETAG" )
    }
    console.log( "UPDATE:REQUEST", etag )
    return this.shop.fetchText( `/shop/rest/data/v1/customer/jsonstore/${(name)}?utag=${etag}`, { method: 'POST', body: JSON.stringify( value ) } )
               .then( res => {
                 if ( !res ) {
                   console.log( "UPDATE:NOT" )
                   return
                 }
                 this.etagByName[ name ] = res
                 const update = this.updateByName[ name ]
                 if ( update && update.isDirty ) {
                   delete this.updateByName[ name ]
                   console.log( "UPDATE:CONTINUE", update, res )
                   this.put( name, update )
                 }
                 delete this.updateByName[ name ]
                 return res
               } )
               .catch( err => {
                 console.log( "ERROR ON PUT", err )
               } )
  }
  
  delete( name, value, etag ) {
    return this.shop.fetch( `/shop/rest/data/v1/customer/jsonstore/${name}?utag=${etag}`, { method: 'DELETE', body: JSON.stringify( value ) } )
  }
}





// WEBPACK FOOTER //
// ./src/sdk/store/ServerStore.js